module.exports = __webpack_public_path__ + "img/autospin_btn.e6a47ccb.png";